"use strict";

exports.__esModule = true;
exports.LogbookPanelElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _Device = require("../../Device");
var _Logbook = require("../../Logbook");
var _Time = require("../../Time");
var _Core = require("../../Core");
var _common = require("../common");
var _ErrorText = require("../common/AggregateMetricCharts/ErrorText");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Displays logbook for a device
 */

var LogbookPanelElement = exports.LogbookPanelElement = function LogbookPanelElement(props) {
  var width = props.width,
    height = props.height;
  var translator = _react["default"].useContext(_Core.TranslatorContext);
  var translate = translator.translate;
  var device = _react["default"].useContext(_Device.DeviceContext);
  var reportingPeriod = _react["default"].useContext(_Time.ReportingPeriodContext);
  var logbookContextProps = {
    device: device,
    interval: reportingPeriod.interval
  };
  var logbookProps = Object.assign({
    width: width,
    height: height,
    interval: reportingPeriod.interval,
    device: device
  }, (0, _common.getWidgetInteractionProps)(props));
  return device ? /*#__PURE__*/_react["default"].createElement(_Logbook.LogbookContext.Provider, logbookContextProps, /*#__PURE__*/_react["default"].createElement(_Logbook.Logbook, logbookProps)) : /*#__PURE__*/_react["default"].createElement(_ErrorText.ErrorText, null, translate("LogbookPanelElement.noDevicesError", "No device supplied for Logbook Widget"));
};